import { useStreamSettingsStore } from '../../../stores/stream-screen-settings.store';
import { useLiveTopicsEnabledForStation } from './useLiveTopicsEnabledForStation';

/**
 * Returns true when the live topics feature should be shown: the station has the
 * feature enabled (API) and the user has activated it in the audit controls (UI toggle).
 */
export function useLiveTopicsShow(): boolean {
  const enabled = useLiveTopicsEnabledForStation();

  const active = useStreamSettingsStore((state) => state.audit.liveTopics ?? true);

  return enabled && active;
}
